var _g, _rect, _path, _path2, _circle, _circle2, _circle3, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    viewBox: "52.5 74 174 135",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 134,
    r: 60,
    fill: "#60B70A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 134,
    r: 59.5,
    stroke: "#CED3D6"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 53.9,
    y: 143.4,
    width: 7.2,
    height: 7.2,
    rx: 1.6,
    stroke: "#38C5F2",
    strokeWidth: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196.355 90.7481L203.426 85.1697L204.721 94.0827L196.355 90.7481Z",
    stroke: "#EF24DB",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M181.148 186.543L188.219 180.965L189.514 189.878L181.148 186.543Z",
    stroke: "#73B024",
    strokeWidth: 0.8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 222,
    cy: 134.5,
    r: 4.1,
    stroke: "#DAC507",
    strokeWidth: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 204.5,
    r: 4.1,
    stroke: "#37B7FF",
    strokeWidth: 0.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 90.5,
    r: 4.1,
    stroke: "#FF9F2E",
    strokeWidth: 0.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 104,
    width: 60,
    height: 60,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1861_7997",
    x: 0,
    y: 0,
    width: 280,
    height: 280,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.580392 0 0 0 0 0.85098 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1861_7997"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1861_7997",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1861_7997",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1861_7997",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAABqklEQVR4nO3cS07DMBhF4QipXR4UVLElCuyCR9kRlEcXgdoxF1nKIAPUOCF2rpPzzavYPm2STv6qAgAAAAAAAAAAAICTJC0lXUvaStpJOgptjvVZbeuzWw7yNZN0JWnfenm0+ZJ0+Z8QZ5LuWi+Drm7D2fYJct/5Uoi16XObQlqrLg/wcL9DWvuoB339RoA81jFBXjItBtJTTJAPTiqbXUyQQ771zN4hJggyIogZgpghSOlBWj+ATghihiBmCGKGIGYIYoYgZghihiBmCDK1IEiLIGYIYoYgZghihiBzCVKNTIVKtrEsp36CCpVsY9XIVKhkG8ty6ieoUJPdWKkIYoYgZghihiBmCGKGIGYIYoYgZghihiBmCGKGIGYIYoYgZghihiBmCGKGIGYIUmAQhs/k8x0T5D3jgubuLSbI89irnJGHmCCM+DMb8beQ9JlxUXO1j552HSYwj73aifuRdB4VoxGFqdbp3HSK0Rg1HsZiY9hfxqbXqPFGmBXPlEGEaa8XvUP88aBfhzmz4d2ZP49Rwh/sV0mP9dktBokBAAAAAAAAAAAAoJquX3XamKtS6g9TAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmIcon);
export default __webpack_public_path__ + "static/media/confirm-icon.a3a0842aeba672382467003f8197f375.svg";
export { ForwardRef as ReactComponent };